var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-select',{attrs:{"value":_vm.value,"expanded":true,"placeholder":`${_vm.$tc('select')} ${_vm.$tc('month', 2)}`},on:{"input":_vm.onSelect}},_vm._l((_vm.options),function(option){return _c('option',{key:option.key,domProps:{"value":option.key}},[_vm._v(" "+_vm._s(option.value)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }